import { render, staticRenderFns } from "./additional-details.vue?vue&type=template&id=7329af9a"
import script from "./additional-details.vue?vue&type=script&lang=js"
export * from "./additional-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports